<template>
  <el-button @click="onBtnClick">
    <slot />
  </el-button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Ref } from 'vue'

export interface Props {
  delay?: number
  debounce?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  delay: 300,
  debounce: true
})

type Emit = {
  (event: 'click'): void
}
const emit = defineEmits<Emit>()

const timer: Ref<number | null> = ref(null)

const onBtnClick = () => {
  if (!props.debounce) {
    emit('click')
    return
  }
  if (timer.value) {
    window.clearTimeout(timer.value)
  }
  timer.value = window.setTimeout(() => emit('click'), props.delay)
}
defineOptions({
  name: "TqButton",
});
</script>
